<template>
    <div id="muti-pay-dialog">
        <el-dialog :title="dialogTitle" :visible.sync="bidBusiDialogShow2" width="800px" @close="resetForm" center>
            <el-form class="invite-form" label-width="140px" ref="bidBusiForm2" :model="bidBusiForm" :rules="rules" v-if="!isDetail">
                <div v-if="!isInviteBid || bidPayCan1" class="section-title">报价信息-付款信息一（{{pay1}}）</div>
                <el-row v-if="!isInviteBid || bidPayCan1">
                    <el-col :span="12">
                        <el-form-item label="不含税报价：" prop="noTax">
                            <el-input size="medium" v-model.number="bidBusiForm.noTax" clearable>
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="税率：" prop="taxRate">
                            <el-input size="medium" v-model.number="bidBusiForm.taxRate" :maxlength="6" clearable>
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="总报价：" prop="">
                            <el-input size="medium" v-model="priceAll" disabled>
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="总报价大写：" prop="">
                            <el-input size="medium" v-model="priceAllCaps" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div v-if="!isInviteBid || bidPayCan2" class="section-title">报价信息-付款信息二（{{pay2}}）</div>
                <el-row v-if="!isInviteBid || bidPayCan2">
                    <el-col  :span="12">
                        <el-form-item label="报价系数：" prop="priceRatio">
                            <el-input size="medium" v-model.number="bidBusiForm.priceRatio" :maxlength="6" clearable>
                                <template slot="append">%</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总报价：" prop="">
                            <el-input size="medium" v-model="totalPriceTwo" disabled>
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <div class="section-title" style="height: 0px;">&nbsp;</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="总工期：" prop="totalDays">
                            <el-input size="medium" v-model.number="bidBusiForm.totalDays" clearable>
                                <template slot="append">天</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="报价说明：" prop="">
                            <el-input v-model="bidBusiForm.priceRemark" type="textarea" :maxlength="120" :rows="3"
                                      placeholder="请输入内容">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="商务标附件：" prop="">
                            <el-upload
                                class="upload-demo"
                                :before-upload="beforeUpload"
                                :on-remove="handleRemoveBidBusi"
                                :action="uploadApi"
                                :on-success="addBidBusiHandle"
                                :on-error="uploadError"
                                multiple
                                :limit="20"
                                :file-list="bidBusiForm.baseFileList">
                                <el-button size="small" type="primary">商务标上传</el-button>
                                <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                    <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div v-else>
                <div v-if="nowBidPay1" class="section-detail-title">报价信息-付款信息一（{{nowBidPay1}}）</div>
                <el-row v-if="nowBidPay1">
                    <el-col :span="4" class="text-right">不含税报价：</el-col>
                    <el-col :span="8">{{ bidBusiData.noTax }} 元</el-col>
                    <el-col :span="4" class="text-right">税率：</el-col>
                    <el-col :span="8">{{ bidBusiData.taxRate }} %</el-col>
                </el-row>
                <el-row v-if="nowBidPay1">
                    <el-col :span="4" class="text-right">总报价：</el-col>
                    <el-col :span="8">{{ bidBusiData.totalPrice }} 元</el-col>
                    <el-col :span="4" class="text-right">总报价大写：</el-col>
                    <el-col :span="8">{{ bidBusiData.totalPriceCapital }}</el-col>
                </el-row>
                <div v-if="nowBidPay2" class="section-detail-title">报价信息-付款信息二（{{nowBidPay2}}）</div>
                <el-row v-if="nowBidPay2">
                    <el-col :span="4" class="text-right">报价系数：</el-col>
                    <el-col :span="8">{{ bidBusiData.priceRatio }} %</el-col>
                    <el-col :span="4" class="text-right">总报价：</el-col>
                    <el-col :span="8">{{ bidBusiData.totalPriceTwo }} 元</el-col>
                </el-row>
                <div class="section-title" style="height: 0px;">&nbsp;</div>
                <el-row>
                    <el-col :span="4" class="text-right">总工期：</el-col>
                    <el-col :span="8">{{ bidBusiData.totalDays }} 天</el-col>
                    <el-col :span="4" class="text-right">报价说明：</el-col>
                    <el-col :span="8">{{ bidBusiData.priceRemark }}</el-col>
                </el-row>
                <el-row v-if="isStandard">
                    <el-col :span="5" class="text-right">标准清单：</el-col>
                    <el-col :span="19">
                        <a v-if="iframeUrl" :href="
                            iframeUrl
                            +'&listid='+ encodeURIComponent(encodeURIComponent(bidBusiData.inviteProjectId))
                            +'&periodid='+ encodeURIComponent(encodeURIComponent(bidBusiData.nviteProjectEntryId))
                            +'&creator='+ encodeURIComponent(encodeURIComponent(bidBusiData.supplierId))
                            +'&typeid='+ bidBusiData.id
                        " target="_blank">查看详情
                        </a>
                        <a v-else :href="
                            'http://10.192.1.6:8082/WebReport/ReportServer?reportlet=ListDahua_View.cpt&op=view'
                            +'&listid='+ encodeURIComponent(encodeURIComponent(bidBusiData.inviteProjectId))
                            +'&periodid='+ encodeURIComponent(encodeURIComponent(bidBusiData.nviteProjectEntryId))
                            +'&creator='+ encodeURIComponent(encodeURIComponent(bidBusiData.supplierId))
                            +'&typeid='+ bidBusiData.id
                        " target="_blank">查看详情
                        </a>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="5" class="text-right">商务标附件：</el-col>
                    <el-col :span="19">
                        <div v-if="bidBusiData.baseFileList.length==0" class="no-data-tip"></div>
                        <ul v-else>
                            <li v-for="li in bidBusiData.baseFileList"><a :href="downloadApi +'?fileId='+ li.id"
                                                                          target="_blank">{{ li.fileOldName }}</a></li>
                        </ul>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" v-if="isDetail">
                <el-button @click="closeDilalog">关 闭</el-button>
            </span>
            <span slot="footer" class="dialog-footer" v-else>
                <el-button type="primary" @click="addBidBusi" v-if="!isInviteBid || bidPayCan">提 交</el-button>
                <el-button @click="closeDilalog">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import util from '@/util'
    export default {
        name: "muti-pay-dialog",
        props: {
            pay1: {
                type: String,
                default: null
            },
            pay2: {
                type: String,
                default: null
            },
            isStandard: {
                type: Boolean,
                default: false
            },
            isInviteBid: {
                type: Boolean,
                default: false
            },
            iframeUrl: {
                type: String,
                default: null
            },
            newFlag: {
                type: Boolean,
                default: false
            },
            bidPayCan: {
                type: Boolean,
                default: false
            },
            bidPayCan1: {
                type: Boolean,
                default: false
            },
            bidPayCan2: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            dialogTitle(){
                if (this.isInviteBid){
                    return this.isDetail ? '商务标询标详情' : '商务标询标'
                }else {
                    return this.isDetail ? '我的商务标回标' : '新增商务标回标'
                }
            },
            // 商务标价格计算
            priceAll() {
                return this.bidBusiForm.noTax * (1000000 + parseInt(this.bidBusiForm.taxRate * 10000)) / 1000000
            },
            priceAllCaps() {
                return convertCurrency(this.priceAll)
            },
            totalPriceTwo() {
                let price = this.priceAll * parseInt(this.bidBusiForm.priceRatio * 10000) / 1000000;
                if(isNaN(price)){
                    price = 0;
                }
                if (this.newFlag){
                    price = this.bidBusiForm.noTax * parseInt(this.bidBusiForm.priceRatio * 10000) / 1000000;
                    if(isNaN(price)){
                        price = 0;
                    }
                }
                return price;
                // return this.priceAll * parseInt(this.bidBusiForm.priceRatio * 10000) / 1000000
            },
            noTaxTwo() {
                let price = this.bidBusiForm.noTax * parseInt(this.bidBusiForm.priceRatio * 10000) / 1000000;
                if(isNaN(price)){
                    price = 0;
                }
                return price;
                // return this.priceAll * parseInt(this.bidBusiForm.priceRatio * 10000) / 1000000
            }
        },
        data(){
            return {
                bidBusiData: {},
                isDetail: false,
                bidBusiDialogShow2: false,
                bidBusiForm: {
                    taxRate: '',
                    noTax: '',
                    totalDays: '',
                    priceRatio: '',
                    priceRemark: '',
                    baseFileList: [],
                    changeType: null,
                    returnEntryList: [
                        {}
                    ]
                },
                rules: {
                    noTax: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    taxRate: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    totalDays: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                    priceRatio: [
                        {required: true, message: '必填'},
                        {type: 'number', message: '数字'}
                    ],
                },
                uploadApi: `${util.baseUrl}rest/api/ftpRmq/rmqUpdate`,
                downloadApi: `${util.baseUrl}rest/file/down`,
                fid: decodeURIComponent(this.$route.params.fid),
                supplierId: this.$root.stockId,
                nowPay1:'',
                nowPay2:'',
                nowBidPay1:true,
                nowBidPay2:true
            }
        },
        created() {
        },
        methods: {
            showDetail(bidBusiData){
                this.isDetail = true;
                this.bidBusiData = bidBusiData;
                this.bidBusiDialogShow2 = true
                this.nowBidPay1 = bidBusiData.pay1;
                this.nowBidPay2 = bidBusiData.pay2;
                if(this.bidBusiData.noTax == null){
                    this.nowBidPay1 = false;
                }
                if(this.bidBusiData.noTaxTwo == null){
                    this.nowBidPay2 = false;
                }
            },
            openDialog (bidBusiForm) {
                this.isDetail = false;
                if (bidBusiForm){
                    this.bidBusiForm = bidBusiForm;
                }
                this.bidBusiDialogShow2 = true
            },
            closeDilalog () {
                this.bidBusiDialogShow2 = false
                this.resetForm()
            },
            resetForm () {
                this.bidBusiForm = {
                    taxRate: '',
                    noTax: '',
                    totalDays: '',
                    priceRatio: '',
                    priceRemark: '',
                    baseFileList: [],
                    changeType: null,
                    returnEntryList: [{}]
                };
                if (this.$refs.bidBusiForm2) {
                    this.$refs.bidBusiForm2.resetFields();
                }
            },
            // 上传文件格式验证
            beforeUpload (file) {
                if (file.size / 1024 / 1024 > 100) {
                    this.$alert('上传附件大小请不要超过100M', '文件过大！', {type: 'error'})
                    return false
                }

                if (!util.allowUpload(file.name)) {
                    this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`, '文件类型不支持，已取消上传！', {type: 'error'})
                    return false
                }
                return true
            },
            uploadError () {
                this.$message({message: '上传出错，请稍后再试。', type: 'error'})
            },
            handleRemoveBidBusi: function (file, fileList) {
                this.bidBusiForm.baseFileList = this.bidBusiForm.baseFileList.filter(function (f) {
                    return f.uid !== file.uid
                })
            },
            addBidBusiHandle: function (response, file, fileList) {
                // if(file.status=='success'){
                this.bidBusiForm.baseFileList = __getBaseFiles__(file, fileList)
                // }
            },
            addBidBusi: function (isDraft) {
                if (this.bidBusiForm.totalDays > 9999) {
                    this.$message({message: '总工期时间过长', type: 'error'})
                    return
                }

                this.$refs['bidBusiForm2'].validate((valid) => {
                    if (valid) {
                        var data = {};
                        Object.assign(
                            data,
                            this.bidBusiForm,
                            {
                                totalPrice: this.bidPayCan1 ? this.priceAll : null,
                                totalPriceCapital: this.bidPayCan1 ? this.priceAllCaps : null,
                                totalPriceTwo: this.bidPayCan2 ? this.totalPriceTwo : null,
                                pay1: this.pay1,
                                pay2: this.pay2,
                                noTaxTwo: this.bidPayCan2 ? this.noTaxTwo : null
                            }
                        )
                        this.$emit('formSubmit', data);
                    } else {
                        this.$message({message: '表单填写有误，请注意必填信息是否填写完整（报价、工期等）', type: 'error'})
                        return false
                    }
                })
            },
        }
    }

    function __getBaseFiles__ (file, fileList) {
        let fs = []
        fileList.forEach(function (item) {
            console.log(item)
            if (item.response) {
                let f = item.response.basefiles[0]
                item.bizTableName = f.bizTableName
                item.bizTablePkName = f.bizTablePkName
                item.bizTablePkValue = f.bizTablePkValue
                item.fid = f.fid
                item.fileCatagoryId = f.fileCatagoryId
                item.fileDesc = f.fileDesc
                item.fileOldName = f.fileOldName
                item.name = f.fileOldName
                item.fileName = f.fileName
                item.filePath = f.filePath
                item.fileSize = f.fileSize
                item.fileType = f.fileType
                item.sort = f.sort
            }
            fs.push(item)
        })
        console.log(fs)
        return fs
    }

    // 数字转中文人名币大写
    function convertCurrency (currencyDigits) {
// Constants:
        var MAXIMUM_NUMBER = 99999999999.99
        // Predefine the radix characters and currency symbols for output:
        var CN_ZERO = '零'
        var CN_ONE = '壹'
        var CN_TWO = '贰'
        var CN_THREE = '叁'
        var CN_FOUR = '肆'
        var CN_FIVE = '伍'
        var CN_SIX = '陆'
        var CN_SEVEN = '柒'
        var CN_EIGHT = '捌'
        var CN_NINE = '玖'
        var CN_TEN = '拾'
        var CN_HUNDRED = '佰'
        var CN_THOUSAND = '仟'
        var CN_TEN_THOUSAND = '万'
        var CN_HUNDRED_MILLION = '亿'
        var CN_SYMBOL = ''  // "人民币";
        var CN_DOLLAR = '元'
        var CN_TEN_CENT = '角'
        var CN_CENT = '分'
        var CN_INTEGER = '整'

// Variables:
        var integral    // Represent integral part of digit number.
        var decimal    // Represent decimal part of digit number.
        var outputCharacters    // The output result.
        var parts
        var digits, radices, bigRadices, decimals
        var zeroCount
        var i, p, d
        var quotient, modulus

// Validate input string:
        currencyDigits = currencyDigits.toString()
        if (currencyDigits == '') {
            // window.ji && ji.$message({message:"请输入小写金额！",type:'error'});
            return ''
        }
        if (currencyDigits.match(/[^,.\d]/) != null) {
            // window.ji && ji.$message({message:"小写金额含有无效字符！",type:'error'});
            return ''
        }
        if ((currencyDigits).match(/^((\d{1,3}(,\d{3})*(.((\d{3},)*\d{1,3}))?)|(\d+(.\d+)?))$/) == null) {
            // window.ji && ji.$message({message:"小写金额的格式不正确！",type:'error'});
            return ''
        }

// Normalize the format of input digits:
        currencyDigits = currencyDigits.replace(/,/g, '')    // Remove comma delimiters.
        currencyDigits = currencyDigits.replace(/^0+/, '')    // Trim zeros at the beginning.
        // Assert the number is not greater than the maximum number.
        if (Number(currencyDigits) > MAXIMUM_NUMBER) {
            // window.ji && ji.$message({message:"金额过大，应小于1000亿元！",type:'error'});
            return ''
        }

// Process the coversion from currency digits to characters:
        // Separate integral and decimal parts before processing coversion:
        parts = currencyDigits.split('.')
        if (parts.length > 1) {
            integral = parts[0]
            decimal = parts[1]
            // Cut down redundant decimal digits that are after the second.
            decimal = decimal.substr(0, 2)
        } else {
            integral = parts[0]
            decimal = ''
        }
        // Prepare the characters corresponding to the digits:
        digits = new Array(CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE)
        radices = new Array('', CN_TEN, CN_HUNDRED, CN_THOUSAND)
        bigRadices = new Array('', CN_TEN_THOUSAND, CN_HUNDRED_MILLION)
        decimals = new Array(CN_TEN_CENT, CN_CENT)
        // Start processing:
        outputCharacters = ''
        // Process integral part if it is larger than 0:
        if (Number(integral) > 0) {
            zeroCount = 0
            for (i = 0; i < integral.length; i++) {
                p = integral.length - i - 1
                d = integral.substr(i, 1)
                quotient = p / 4
                modulus = p % 4
                if (d == '0') {
                    zeroCount++
                } else {
                    if (zeroCount > 0) {
                        outputCharacters += digits[0]
                    }
                    zeroCount = 0
                    outputCharacters += digits[Number(d)] + radices[modulus]
                }
                if (modulus == 0 && zeroCount < 4) {
                    outputCharacters += bigRadices[quotient]
                    zeroCount = 0
                }
            }
            outputCharacters += CN_DOLLAR
        }
        // Process decimal part if there is:
        if (decimal != '') {
            for (i = 0; i < decimal.length; i++) {
                d = decimal.substr(i, 1)
                if (d != '0') {
                    outputCharacters += digits[Number(d)] + decimals[i]
                }
            }
        }
        // Confirm and return the final output string:
        if (outputCharacters == '') {
            outputCharacters = CN_ZERO + CN_DOLLAR
        }
        if (decimal == '') {
            outputCharacters += CN_INTEGER
        }
        outputCharacters = CN_SYMBOL + outputCharacters
        return outputCharacters
    }
</script>

<style scoped lang="postcss">
    .section-title {
        border-bottom: 2px dashed #ddd;
        padding: 0px 0 4px;
        margin-bottom: 10px;
        margin-top:10px;
        font-weight: bold;
    }
    .section-detail-title {
        padding: 0px 0 4px;
        font-weight: bold;
        margin-bottom: 5px;
        margin-top: 5px;
    }
    ul {
        padding: 0;
        margin: 0;
    }

    ul li {
        list-style: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/invite/components/MutiPayDialog.vue